import { apiClient } from 'api/apiClient';
import { ParentAccountsResponse } from 'api/techexpress/schemas/ParentAccountsResponse';
import {
  DraftOrderAPIResponse,
  OrderResponse,
  OrdersAPIResponseSchema,
  OrdersFilterSearchParams,
  OrdersFilterSearchParamsSchema,
  OrdersIndexAPIResponse,
  PostDraftRequest,
  PostOrderItems,
} from './schemas/OrdersSchemas';
import { prepareSortingParams } from 'api/common-schemas';
import { CreateQuoteRequest } from './schemas/QuotesSchemas';
import { AxiosRequestConfig } from 'axios';
import {
  CompanyPreferencesRequest,
  CompanyPreferencesResponse,
} from 'screens/AccessExpressV3/BaseComponents/Cart/locationFlow/access/ConfigRequirementsModal/schema';

export const getAccessParentAccounts = async (): Promise<
  ParentAccountsResponse[]
> => {
  const response = await apiClient.get('/api/v1/orders/parents');
  return response.data?.data;
};

export const postCompanyPreferences = async (
  data: CompanyPreferencesRequest,
): Promise<CompanyPreferencesResponse> => {
  const response = await apiClient.post(
    '/api/v1/access/company/preferences',
    data,
  );
  return response.data;
};

export const getCompanyPreferences =
  async (): Promise<CompanyPreferencesResponse> => {
    const response = await apiClient.get('/api/v1/access/company/preferences');
    return response.data;
  };

const mapOrderColumns = {
  customer_name_order: 'customer_name',
  requester_order: 'requester',
  order_number_order: 'order_number',
  updated_at_order: 'updated_at',
  created_at_order: 'created_at',
};

export const getOrdersIndex = async (
  params: OrdersFilterSearchParams = {},
): Promise<OrdersIndexAPIResponse> => {
  const newQueryParams = prepareSortingParams(
    params,
    mapOrderColumns,
    OrdersFilterSearchParamsSchema,
  );

  const response = await apiClient.get('/api/v1/orders', {
    params: {
      ...newQueryParams,
      sort_field: newQueryParams.sort_column,
      status: 'submitted',
    },
  });
  return OrdersAPIResponseSchema.parse(response.data);
};

export const getOrderDetails = async (id: string): Promise<OrderResponse> => {
  const response = await apiClient.get<OrderResponse>(`/api/v1/orders/${id}`);
  return response.data;
};

export const getLastDraftOrder =
  async (): Promise<DraftOrderAPIResponse | null> => {
    const response = await apiClient.get('/api/v1/orders/draft');

    return response.data;
    // if (orders.data.length) return orders.data[0];
    // return null;
  };

//orders
export const postOrder = async (
  body: PostDraftRequest,
  config?: AxiosRequestConfig,
): Promise<DraftOrderAPIResponse> => {
  const response = await apiClient.post(`/api/v1/orders`, body, config);

  return response.data;
};

export const submitOrder = async (
  orderId: string,
  body: { order_name: string },
): Promise<DraftOrderAPIResponse> => {
  const response = await apiClient.post(
    `/api/v1/orders/${orderId}/submit`,
    body,
  );
  return response.data;
};

export const updateOrder = async (
  body: Omit<PostDraftRequest, 'status'>,
  orderId: string,
  config?: AxiosRequestConfig,
): Promise<DraftOrderAPIResponse> => {
  const response = await apiClient.patch(
    `/api/v1/orders/${orderId}`,
    body,
    config,
  );

  return response.data;
};

export const postQuote = async (
  body: CreateQuoteRequest,
  config?: AxiosRequestConfig,
) => {
  const response = await apiClient.post(`/api/v1/quotes/slim`, body, config);

  return response.data;
};

export const addOrderItems = async (
  body: PostOrderItems,
  locationId: string,
): Promise<DraftOrderAPIResponse> => {
  const response = await apiClient.patch(
    `/api/v1/orders/locations/${locationId}`,
    body,
  );

  return response.data;
};

export const clearAllOrderItems = async (
  orderId: string,
): Promise<DraftOrderAPIResponse> => {
  const response = await apiClient.patch(`/api/v1/orders/${orderId}/clear`);

  return response.data;
};
